import { useState, useEffect, useRef } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Box, Button } from '.';
import "./css/popup.css";
import { useApp } from '../../contexts';
import { translateText } from '../../helpers/util';

const clickAway = (ref, callback) => {
  useEffect(() => {
    const handleClickAway = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }
    document.addEventListener("mousedown", handleClickAway);
    return () => {
      document.removeEventListener("mousedown", handleClickAway);
    };
  }, [ref]);
}

export const PopUp = ({ text, children, buttonFooter, onClose }) => {
  const { userCountry, language, translations } = useApp()
  const [open, setOpen] = useState(false);
  const targetElement = useRef(null)

  const handleClick = () => {
    setOpen(!open);
  };

  const handleButton = () => {
    close();
    onClose();
  }

  const close = () => {
    setOpen(false);
  }

  clickAway(targetElement, close)

  return (
    <div style={{ position: 'relative' }} ref={targetElement}>
      <div className="button-pop-up" onClick={handleClick}>
        {text}
        <ArrowDropDownIcon />
      </div>
        <div style={{ ...styles.popUp, display: open ? "flex" : "none" }}>
          {children}
          {buttonFooter &&
            <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'end', marginTop: 1}}>
                  <Button
                  sx={{ backgroundColor: "#04577F", 
                      color: '#FFF', 
                      width: 100,
                      height: 40, 
                      transition: '0.2s',
                      textTransform: "capitalize", 
                      '&:hover': {
                          backgroundColor: "#04577F",
                          opacity: 0.7
                      } 
                  }} 
                  onClick={handleButton}
                  > {translateText("Aplicar", language, translations, userCountry)}</Button>
              </Box>
          }
        </div>
    </div>
  );
}

const styles = {
  popUp: { 
    position: 'absolute', 
    zIndex: 99999, 
    top: 45, 
    right: 0,
    padding: "10px 15px", 
    width: 350,
    backgroundColor: '#FFF', 
    borderRadius: 5, 
    boxShadow: "0 4px 4px 3px #00000040",
    flexDirection: "column",
  }
}